import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components-shared/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components-shared/LanguageSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
